import { MessagingCenter } from '../../../../../components/MessagingCenter/MessagingCenter.js';
export const SupportCasesPath = () => <MessagingCenter />;
